<template>
  <div class="push-notification">
    <Widget :title="$t('push_notification')">
      <b-row>
        <b-col lg="12" md="12">
          <b-form-group>
            <b-form>
              <b-form-group
                horizontal
                :label="$t('users')"
                label-for="user"
                label-class="text-md-right"
                :label-cols="4"
                breakpoint="md"
              >
                <multiselect
                  v-model="selectedUser"
                  :options="usersWithFcmToken"
                  track-by="number"
                  :placeholder="$t('users') + ' ' + $t('select')"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :show-labels="false"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    {{ option.firstname }} {{ option.lastname }}
                  </template>
                  <template slot="option" slot-scope="{ option }">
                    {{ option.firstname }} {{ option.lastname }}
                  </template>
                </multiselect>
              </b-form-group>

              <b-form-group
                horizontal
                :label="$t('title')"
                label-for="title"
                label-class="text-md-right"
                :label-cols="4"
                breakpoint="md"
              >
                <b-form-input v-model="title" type="text" id="title" :placeholder="$t('title')" />
              </b-form-group>

              <b-form-group
                horizontal
                :label="$t('message')"
                label-for="message"
                label-class="text-md-right"
                :label-cols="4"
                breakpoint="md"
              >
                <b-form-textarea
                  v-model="message"
                  id="message"
                  :placeholder="$t('message_content_placeholder')"
                  rows="5"
                  max-rows="10"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                horizontal
                :label="$t('url')"
                label-for="url"
                label-class="text-md-right"
                :label-cols="4"
                breakpoint="md"
              >
                <b-form-input v-model="url" type="text" id="url" :placeholder="$t('url')" />
              </b-form-group>
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            model="notificationModel"
            :showSaveAndBackButton="false"
            :showDeleteButton="false"
            :showCancelButton="false"
            :createCallback="sendNotification"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Multiselect from 'vue-multiselect';
import ButtonBar from '@/components/ButtonBar.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PushNotification',
  components: {
    Widget,
    Multiselect,
    ButtonBar,
  },
  data() {
    return {
      selectedUser: null,
      title: '',
      message: '',
      url: '',
    };
  },
  computed: {
    ...mapGetters(['getUsers']),
    users() {
      return this.getUsers;
    },
    usersWithFcmToken() {
      return this.users.filter((user) => user.fcmToken);
    },
    isFormValid() {
      return this.selectedUser && this.title.trim() && this.message.trim();
    },
    notificationModel() {
      return {
        number: '_new',
        userId: this.selectedUser ? this.selectedUser.id : null,
        title: this.title,
        message: this.message,
        url: this.url,
      };
    },
  },
  methods: {
    ...mapActions(['fetchUsers', 'sendPushNotification']),
    sendNotification(model) {
      if (!this.isFormValid) return;

      const notification = {
        userId: this.selectedUser.id,
        title: this.title,
        message: this.message,
        url: this.url,
      };

      return this.sendPushNotification(notification)
        .then(() => {
          // this.selectedUser = null;
          // this.title = '';
          // this.message = '';
        })
        .catch((error) => {
          console.error('Error sending push notification:', error);
          throw error;
        });
    },
  },
  mounted() {
    this.fetchUsers();
  },
};
</script>

<style scoped>
.push-notification {
  margin: 20px 0;
}
</style>
